import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsInvoiceninjaComponent } from './simple-icons-invoiceninja.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsInvoiceninjaComponent ],
    exports:      [ SimpleIconsInvoiceninjaComponent ],
    bootstrap:    []
})
export class SimpleIconsInvoiceninjaModule {}
